const icon = require('./icons/walking-100.png')

export const WalkingIcon = () => {
  return <img src={icon} alt="walking icon" className="w-full h-full"/>
}
